import {get, isNil} from 'lodash'
import {accountHasFeature, checkProVersion} from 'helpers/user'
import {features, pricingGroupsSyncVersion} from 'helpers/constants'

export const nullPricingGroup = {
  id: -1,
  name: null,
  description: null,
  createdDate: null,
  modifiedDate: null,
  guid: null,
  items: [],
  deletedItems: [],
  companies: [],
  deletedCompanies: [],
}

export const isPricingGroupsEnabled = (user) => {
  return (
      accountHasFeature(user, features.PRICING_GROUPS) &&
      checkProVersion(user, pricingGroupsSyncVersion, true)
  )
}

export const getDiscountLabel = (pricingGroup) => {
  const pricingGroupItems = get(pricingGroup, 'items', [])
  if (isNil(pricingGroupItems) || pricingGroupItems.length === 0) {
    return null
  }

  if (pricingGroupItems.length === 1) {
    return `${get(pricingGroupItems[0], 'discount', 0)}% discount`
  }

  const minDiscountItem = pricingGroupItems
      .reduce((a, b) => a.discount < b.discount ? a : b)

  const maxDiscountItem = pricingGroupItems
      .reduce((a, b) => a.discount > b.discount ? a : b)

  return `${minDiscountItem.discount} - ${maxDiscountItem.discount}% discount`
}

export const getPricingGroupCompanies = (pricingGroup) => {
  const companies = get(pricingGroup, 'companies', [])
  return isNil(companies) ? [] : companies
}

export const getDeletedPricingGroupCompanies = (pricingGroup) => {
  const deletedCompanies = get(pricingGroup, 'deletedCompanies', [])
  return isNil(deletedCompanies) ? [] : deletedCompanies
}

export const updatePricingGroupCompanies = (companies, pricingGroupCompany) => {
  const companyIndex = companies.findIndex(company => company.id === pricingGroupCompany.id)
  const isExistingCompany = companyIndex !== -1
  if (isExistingCompany) {
    companies[companyIndex] = pricingGroupCompany
  } else {
    companies = [
      ...companies,
      pricingGroupCompany,
    ]
  }

  return companies
}

export const toggleCheckCompany = (pricingGroup, pricingGroupCompany, checked) => {
  const companies = getPricingGroupCompanies(pricingGroup)
  const deletedCompanies = getDeletedPricingGroupCompanies(pricingGroup)
  pricingGroupCompany['checked'] = checked
  pricingGroup['companies'] = companies.map(company => {
    if (company.id === pricingGroupCompany.id) {
      company['checked'] = checked
      return company
    }

    return company
  })

  pricingGroup['deletedCompanies'] = checked
      ? deletedCompanies.filter(company => company.id !== pricingGroupCompany.id)
      : updatePricingGroupCompanies(deletedCompanies, pricingGroupCompany)

  return pricingGroup
}

export const unCheckCompanies = (pricingGroup) => {
  const companies = getPricingGroupCompanies(pricingGroup)
  const deletedCompanies = getDeletedPricingGroupCompanies(pricingGroup)

  pricingGroup['companies'] = companies.map(company => {
    company['checked'] = false
    return company
  })

  pricingGroup['deletedCompanies'] = deletedCompanies.concat(companies)

  return pricingGroup
}
